import React from 'react';
import { IconLock, IconShieldLock } from '@tabler/icons-react';

export const UnauthViewModal = ({ tabName }) => {
    const brandColor = "#7a3a5e";

    return (
        <div
            className="d-flex align-items-center justify-content-center border-0 shadow-sm"
            style={{
                minHeight: '480px',
                width: '100%',
                // A soft, sophisticated "Off-White to Lavender" gradient
                background: 'linear-gradient(135deg, #f8fafc 0%, #f1f1f6 100%)',
                borderRadius: '16px',
            }}
        >
            <div className="text-center p-5" style={{ maxWidth: '460px' }}>

                {/* Visual Lock Icon */}
                <div className="mb-4 position-relative d-inline-block">
                    <div
                        className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                        style={{
                            width: '100px',
                            height: '100px',
                            backgroundColor: '#fff',
                            border: '1px solid #e2e8f0',
                        }}
                    >
                        <IconLock size={44} color={brandColor} stroke={1.5} />
                    </div>
                    {/* Subtle outer accent ring */}
                    <div
                        className="position-absolute top-50 start-50 translate-middle rounded-circle"
                        style={{
                            width: '130px',
                            height: '130px',
                            border: `1px dashed ${brandColor}`,
                            opacity: 0.15
                        }}
                    />
                </div>

                {/* Text Content */}
                <div className="mb-0 d-flex flex-column  align-items-center ">
                    <span className="fw-bold mb-2 text-center" style={{ color: '#1e293b', letterSpacing: '-0.2px' }}>
                        Access Restricted
                    </span>

                    <div
                        className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill mb-3"
                        style={{
                            backgroundColor: 'rgba(122, 58, 94, 0.08)',
                            color: brandColor,
                            fontSize: '12px',
                            fontWeight: '600',
                            border: `1px solid rgba(122, 58, 94, 0.1)`
                        }}
                    >
                        <IconShieldLock size={14} />
                        {tabName}
                    </div>

                    <p
                        className="mb-0 mx-auto px-2"
                        style={{
                            fontSize: '15px',
                            lineHeight: '1.6',
                            color: '#64748b'
                        }}
                    >
                        You are not authorized to view this section. <br />
                        Please contact your <span className="fw-bold" style={{ color: brandColor }}>Administrator</span> for the required permissions.
                    </p>
                </div>
            </div>
        </div>
    );
};